import { FooterProps } from '@design-system/footer';
import React from 'react';

import Splitter from '~/components/Splitter';
import TMPLinkWrap from '~/components/TMPLinkWrap';
import { iconMapper } from '~/mappers/common';
import { linkMapper } from '~/mappers/link';
import { typographyMapper } from '~/mappers/typography';

import { countryPickerMapper } from '../countryPicker';
import {
  FooterBasic,
  FooterCommon,
  FooterSplitterAdditionalData,
  FooterWithSplitter,
} from './models';

const commonFooterMapper = ({ uid, mode, medicalAddon }: FooterCommon) => ({
  uid,
  mode,
  medicalAddon: medicalAddon?.map((item) => ({
    ...item,
    icon: { props: iconMapper(item.icon[0]) },
  })),
});

const footerBasicMapper = ({
  navigation,
  socialLinks,
  legal,
  disclaimer,
  isCookieModal,
  cookieButtonText,
  privacyNoteText,
  countryPicker,
  ...commonProps
}: FooterBasic): FooterProps => ({
  ...commonFooterMapper(commonProps),
  navigationData: navigation.map(linkMapper),
  iconsData: socialLinks[0]?.links.map(linkMapper),
  copyright: legal,
  iconsHeading: socialLinks[0]?.header
    ? typographyMapper({
        ...socialLinks[0].header,
        className: socialLinks[0]?.hideHeader ? 'cds-sr-only' : undefined,
        content: socialLinks[0]?.header.content || 'Social links:',
      })
    : undefined,
  disclaimer,
  LinkNavElement: TMPLinkWrap,
  isCookieModal,
  cookieButtonText,
  privacyNoteText,
  countryPicker: countryPickerMapper(countryPicker),
});

const footerWithSplitterMapper = (
  { splitter, ...commonProps }: FooterWithSplitter,
  footerSplitterAdditionalData?: FooterSplitterAdditionalData
): FooterProps => ({
  ...commonFooterMapper(commonProps),
  splitter: splitter[0] ? (
    <Splitter {...splitter[0]} {...footerSplitterAdditionalData} />
  ) : undefined,
});

export const footerMapper = ({
  footerBasic,
  footerWithSplitter,
  footerSplitterAdditionalData,
}: {
  footerBasic?: FooterBasic | null;
  footerWithSplitter?: FooterWithSplitter | null;
  footerSplitterAdditionalData?: FooterSplitterAdditionalData;
}): FooterProps | null => {
  if (footerWithSplitter) {
    return footerWithSplitterMapper(
      footerWithSplitter,
      footerSplitterAdditionalData
    );
  }

  if (footerBasic) return footerBasicMapper(footerBasic);

  return null;
};
